export interface ProgressActivityModel {
  activitySent: boolean;
  id: string;
  totalEnabledExercises: number;
  totalSavedExercises: number;
}
